import React, { useEffect, useRef, useState } from 'react'
import styles from '../../styles/modals/DemoModal.module.css';
import { RxCross2 } from 'react-icons/rx';
import Image from 'next/image';
import { FormGroup, Input, Label } from 'reactstrap';
import { BlackCustomButton, BlueCustomButton, DropDownInput, TextInput } from '../qbStrap';
import { inter_Medium } from '../common/Fonts';
import { toast } from 'sonner';
import { checkOtp, sendOtp, getFreeDemo } from '@/services/signUpServices';
import { SelectDrop } from '../getFreeDemoNewCont/SelectDrop';
import { useRouter } from 'next/router';
import { getCityData, otpFieldTraversing } from '@/utils';
import { PhoneNumberUtil } from "google-libphonenumber";
import 'react-phone-number-input/style.css'
import PhoneInput from '@/components/common/LocalPhoneInput'
import { useMerchantData } from '@/services/MerchantDataContext';
import CommonForm from '../common/CommonForm';
import NewCommonForm from '../common/NewCommonForm';


const getfreedemoactual = ({ isOpen, closeModal }) => {
  const { merchantCountFormatted } = useMerchantData();
   const [verified, setVerified] = useState(false)
   const [mobileView, setmobileView] = useState(1);

   useEffect(() => {
      setWindowDimensions();
      window.addEventListener("resize", setWindowDimensions);
      return () => {
         window.removeEventListener("resize", setWindowDimensions);
      };
   }, []);

   const setWindowDimensions = () => {
      window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
   };

   return (
      <div className={styles.modal_size} style={{ padding: "2rem", height: "100vh" }} >
         <div style={{ position: 'relative', height: verified ? "95%" : '70%', display: 'flex', justifyContent: 'center' }}>
            <div className={styles.stack1}></div>
            <div className={styles.stack2}></div>
            <div className={styles.inner_modal_container}>
               <NewCommonForm otpFeature={true} setVerified={setVerified} formHeading={'Book your free demo now!'} formDesc={"Fill in your details and our team will get you started."} />
            </div>
         </div>
         {
            !verified &&
            <div className={styles.modal_footer_container}>
               <div className={styles.qblogo}><Image src="/assets/logo.svg" alt="queuebuster logo" fill /></div>
               <p className={styles.text}>Trusted By {merchantCountFormatted} merchants
                  
               </p>
               <div className={styles.icon_container}>
                  <div className={styles.merchants_icons} style={mobileView ? { height: "2rem", width: "8rem" } : { height: "3rem", width: "12rem" }}><Image src="/assets/demo-relaxo.png" alt="relaxo" fill /></div>
                  <div className={styles.merchants_icons} style={mobileView ? { height: "3rem", width: "8rem" } : { height: "5rem", width: "12rem" }}><Image src="/assets/demo-happilo.png" alt="happilo" fill /></div>
                  <div className={styles.merchants_icons} style={mobileView ? { height: "3rem", width: "8rem" } : { height: "5rem", width: "12rem" }}><Image src="/assets/demo-heineken.png" alt="heineken" fill /></div>
                  <div className={styles.merchants_icons} style={mobileView ? { height: "3rem", width: "8rem" } : { height: "5rem", width: "15rem" }}><Image src="/assets/newClients/Client-07.webp" alt="cremica" fill /></div>
                  <div className={styles.merchants_icons} style={mobileView ? { height: "3rem", width: "6rem" } : { height: "5rem", width: "10rem" }}><Image src="/assets/demo-tajstats.png" alt="taj stats" fill /></div>
                  <div className={styles.merchants_icons} style={mobileView ? { height: "4rem", width: "4rem" } : { height: "6rem", width: "7rem" }}><Image src="/assets/demo-itc.png" alt="itc" fill /></div>
                  <div className={styles.merchants_icons} style={mobileView ? { height: "3rem", width: "10rem" } : { height: "5rem", width: "18rem" }}><Image src="/assets/newClients/Client-43.webp" alt="canabeans" fill /></div>
                  <div className={styles.merchants_icons} style={mobileView ? { height: "4rem", width: "10rem" } : { height: "7rem", width: "20rem" }}><Image src="/assets/newClients/Client-01.webp" alt="hul" fill /></div>
               </div>
            </div>
         }
      </div>
   )
}

export default getfreedemoactual
